export const fonts = {
  body: `Myriad Pro, sans-serif`,
  heading: `Pluto Condensed, sans-serif`
};
